import { render, staticRenderFns } from "./poster-long.vue?vue&type=template&id=d265e1c4&scoped=true"
import script from "./poster-long.vue?vue&type=script&lang=js"
export * from "./poster-long.vue?vue&type=script&lang=js"
import style0 from "./poster-long.vue?vue&type=style&index=0&id=d265e1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d265e1c4",
  null
  
)

export default component.exports